export default "__VITE_ASSET__d0ef38dc__"